import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Select, SelectMulti, OfferTile } from "../partials";
import { groupDealerships, insertParam, formatGroupLabel } from "~/js/utils";
import VehicleBrandHero from './VehicleBrandHero';


const offers = window.offers_data ?? [];

const dealership_details = window.dealerships_data ?? [];

const makes = [{ value: '', label: 'All Brands' }];

offers.forEach(offer => {
    const brand = offer.data['offer-details'].brand[0];
    if (brand) {
        const dealerships = offer.data['offer-details']['dealerships'];
        const value = brand.data['brand-details']['make-seq'];
        const label = brand['post_title'];
        const url = brand['post_name'];
        const hero = brand.data['hero'].bg;

        // Check if make already exsists
        const index = makes.findIndex(m => m.value === value);

        if (index === -1) {
            makes.push({ value, label, hero, dealerships, url });
        }
    }
});

const allBrands = makes.find(item => item.value === '');
const otherBrands = makes.filter(item => item.value !== '');

otherBrands.sort((a, b) => a.label.localeCompare(b.label));

const sortedBrands = [allBrands, ...otherBrands];

let regions = [];

class OffersTiles extends Component {

    state = {
        make: { value: ''},
        dealer: null,
        brandHeros: null,
        title: null
    };

    fetchHero(){
        const { make } = this.state;

        if(make !== undefined) {
            if (make.value !== '' || make.value !== undefined) {

                let brandHeros = this.state.brandHeros ?? [];
                fetch(`/api/v1/image/${make.hero}/1536x1536}`)
                    .then((res) => res.json())
                    .then((data) => {

                        brandHeros[make.hero] = data[0];

                        this.setState({
                            brandHeros: brandHeros
                        }, function () {
                        })
                    })
                    .catch((err) => console.log(err))
            }
        }
    }

    constructor(props){
        super(props);
        regions = props.regions;
        regions.forEach(region => {
            const filteredDealerships = [];

            offers.forEach(offer => {
                const offerDealerships = [...Object.values(offer.data['offer-details']['dealerships'])];

                // for each region dealerships
                if (region.dealerships) {
                    [...Object.values(region.dealerships)].forEach(dealership => {
                        // See if each particular dealership exists inside each offer dealerships
                        const index = offerDealerships.findIndex(d => d['ID'] === dealership['ID']);

                        // If it does, allow to show this dealership
                        if (index !== -1) {

                            // check if it already exists
                            const exists = filteredDealerships.findIndex(fd => fd['ID'] === dealership['ID']);

                            if (exists === -1) {
                                if (dealership_details.length > 0) {
                                    dealership_details.forEach((dlr) => {
                                        if (dlr['ID'] == dealership['ID']) {
                                            filteredDealerships.push(dealership);

                                        }
                                    });
                                } else {
                                    filteredDealerships.push(dealership);
                                }
                            }
                        }
                    });
                }
            })

            // If found at least one dealership that is used in the offers
            if (filteredDealerships.length > 0) {
                // reaplce current region's dealerships field, with filtered ones
                region.dealerships = filteredDealerships;

            }
        });

        let dealershipsGrouped = groupDealerships(regions);
        const urlParams = new URLSearchParams(window.location.search);
        const self = this;

        this.urlParams = new URLSearchParams(window.location.search);

        this.filters = {
            makes: {
                field: {
                    onChange: (make) => {
                        this.setState({ make }, function(){
                            this.fetchHero();
                        });
                        let title = "";
                        if(dealership_details.length > 0){
                            title = 'Vehicle Offers';
                        }else{
                            title = window.offer_title;
                        }
                        if(make.label != "All Brands") {
                            title += " - " + make.label;
                        }
                        self.state.title = title;
                        insertParam('make', make.label.replaceAll("-","%").replaceAll(" ", "-").replaceAll("|","-"));
                    },
                    options: sortedBrands,
                    defaultValue: sortedBrands[0]
                },
                apply: (item) => {
                    const { value: id } = this.state.make;
                    if (id === '') return true;
                    const make = item.data['offer-details'].brand[0] ? item.data['offer-details'].brand[0].data['brand-details']['make-seq'] : 0;
                    return parseInt(make) === parseInt(id);
                },
                onInit() {
                    let urlMake = urlParams.get('make');
                    let title = "";
                    if(dealership_details.length > 0){
                        title = 'Vehicle Offers';
                    }else{
                        title = window.offer_title;
                    }
                    if (urlMake) {
                        urlMake = urlMake.replaceAll("-", " ").replaceAll("%", "-");

                        const item = sortedBrands.find(m => m.label === urlMake);
                        if (typeof item !== 'item' && item !== undefined) {
                            self.state.make = item;
                            this.field.preSelect = item;
                            self.fetchHero();
                            if(item.label != "All Brands") {
                                title += " - " + item.label;
                            }
                        }else{
                            self.state.make = sortedBrands[0];
                            this.field.preSelect = sortedBrands[0];
                        }
                    }
                    self.state.title = title;
                }
            },
            dealers: {
                field: {
                    onChange: ( dealer ) => {

                        this.setState({ dealer });
                        let UrlParam = [];
                        if(dealer !== undefined) {
                            dealer.forEach((element) => {
                                if(element.value != null) {
                                    UrlParam.push(element.dealer.post_title.replaceAll("-", "%").replaceAll(" ", "-").replaceAll("|", "-"));
                                }
                            })

                            insertParam('dealership', UrlParam.join(","));
                        }else{
                            insertParam('dealership', null);
                        }
                    },
                    options: dealershipsGrouped,
                    formatGroupLabel: formatGroupLabel
                },
                apply: (item) => {
                    const { dealer } = this.state;
                    if (!dealer) return true;
                    let itemExisits = false;
                    dealer.forEach((element) => {
                        if(element.value != null) {
                            let dealerships = item.data['offer-details']['dealerships'];
                            let exists = dealerships ? dealerships.findIndex(d => d['ID'] === element.dealer['ID']) : -1;
                            if (exists !== -1) {
                                itemExisits = true;
                            }
                        }
                    })
                    if(dealer.length == 1 && dealer[0].value == null){
                        itemExisits = true;
                    }
                    if(dealer.length == 0){
                        itemExisits = true;
                    }
                    return itemExisits;

                },
                onInit() {
                    let urlMake = urlParams.get('dealership');
                    if (urlMake) {
                        urlMake = urlMake.replaceAll("---", " | ").replaceAll("-"," ").replaceAll("%", "-");
                        let foundDealer;
                        let urlMakeArray = urlMake.split(",");
                        let dealerArray = []
                        dealershipsGrouped.forEach((dealer) =>{
                                   let options = (dealer['options']);
                                   if(options !== undefined){
                                       options.forEach((item)=>{
                                           urlMakeArray.forEach((urlMaker) => {
                                               if(item.value === urlMaker){
                                                   foundDealer = item;
                                                   dealerArray.push(foundDealer)
                                               }
                                           })
                                        });
                                   }
                            }
                        );
                        if(dealerArray.length > 0){
                            self.state.dealer = dealerArray;
                            this.field.preSelect = dealerArray;

                        }
                    }
                },

            }
        }

        // Run init functions for filter if exists
        //UYSed for applying url params
        for (const key in this.filters) {
            const filter = this.filters[key];

            if (filter.hasOwnProperty('onInit')) {
                filter['onInit']();
            }
        }
    };

    componentDidMount(){

    }


    renderItem = (item, index) => {
        // Check all filters
        // If at least one doesnt pass, return null
        for (const key in this.filters) {
            const filter = this.filters[key];
            // console.log(filter, filter.apply(item));
            if (!filter.apply(item)) return null;
        }

        return (
            <div className="offers-tiles__item" key={index}>
                <OfferTile {...item} />
            </div>
        );
    };

    render() {
        const title = window.offer_title;
        const { make } = this.state;
        const isAutobodyOffers = window.is_autobody_offers;
        const isRegionalDealershp = window.is_regional_dealership;

        const hasGenericHero = document.getElementById("offer-replacement-banner");
        let sortTiles = (
            <div>
                <div className={`offers-tiles__select`}>
                    <Select { ...this.filters.makes.field } modifiers={['form']}/>
                </div>
                <div className={`offers-tiles__select-multi`}>
                    <SelectMulti { ...this.filters.dealers.field } modifiers={['form', 'left-menu']}/>
                </div>
            </div>)
        if(isRegionalDealershp){
            sortTiles = (<div>
                <div className={`offers-tiles__select`}><Select { ...this.filters.dealers.field } modifiers={['form', 'left-menu']}/></div></div>)

        }

        return (
            <Fragment>

                { (make.value !== '' && this.state.brandHeros && !hasGenericHero) ?
                    <VehicleBrandHero
                        button={{
                            title: `More about ${make.label}`,
                            link: `/our-brands/${make.url}`,
                        }}
                        src={this.state.brandHeros[make.hero] ?? null}
                        />
                : null }

                <div className={`offers-tiles__container`}>
                    <div className={`offers-tiles__wrap`}>
                        <div className={`offers-tiles__head`}>
                            <h1 className={`offers-tiles__h`}>{ this.state.title }</h1>
                            {
                                (isAutobodyOffers) ? '' : (
                                    <div className={`offers-tiles__sort`}>
                                        <label>Filter by:</label>
                                        { sortTiles }
                                    </div>
                               )
                            }
                        </div>

                        <div className={`offers-tiles__list`}>
                            { offers.map(this.renderItem) }
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default function (el, props) {
    ReactDOM.render(<OffersTiles {...props} />, el)
}
